/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import AccordionSummary from "@mui/material/AccordionSummary";
import { useMediaQuery } from "@mui/material";
import Typography from "@mui/material/Typography";
import {
	BgBrush,
	CustomAccordion,
	DotIcon,
	Container,
	ItemsContainer,
	Title,
	Character,
	CustomAccordionDetails,
	CustomTypography
} from "./styles";
import { faqAssets } from "assets/cdn";
import { faqData } from "./helpers";
import { useGoogleAnalyticsContext } from "contexts";
import { useImagePath } from "hooks/useImagePath";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { CrownIconV2 } from "utils/svgIcons";

export const FAQ = () => {
	const { getImage } = useImagePath("cdn");
	const isLandscape = useMediaQuery("(orientation: landscape)");
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const backgroundImage = getImage(
		isLandscape ? faqAssets.background : faqAssets.backgroundMobile
	);
	const arrowImage = getImage(faqAssets.arrow);
	const brushImage = getImage(faqAssets.brushMobile);
	const loyaltyImage = getImage(faqAssets.loyalty);
	const mini1Image = getImage(faqAssets.mini1);
	const mini2Image = getImage(faqAssets.mini2);

	const [expanded, setExpanded] = React.useState<number>(0);

	const handleChange =
		(panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
			setExpanded(isExpanded ? panel : 0);
			reportEvent("FAQ", {
				source: isExpanded ? "expand" : "minimize",
				question_copy: faqData[panel - 1].question,
				answer_copy: faqData[panel - 1].answer
			});
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "FAQ",
				event_type: "shop_visual_update",
				action: isExpanded ? "expand" : "minimize",
				source: "FAQ",
				section_name: faqData?.[panel - 1]?.question
			});
		};

	return (
		<Container $backgroundImage={backgroundImage}>
			<BgBrush src={brushImage} alt="" />
			<Title>{"GOT QUESTIONS?"}</Title>
			<Character
				src={mini1Image}
				style={{
					right: "50%",
					transform: "translateX(-50%)",
					top: "250px",
					marginRight: "20%"
				}}
			/>
			<Character
				src={mini2Image}
				style={{
					left: "50%",
					transform: "translateX(50%)",
					top: "215px",
					marginLeft: "20%"
				}}
			/>

			<ItemsContainer>
				{faqData.map((item, index) => (
					<CustomAccordion
						key={index}
						expanded={expanded === index + 1}
						onChange={handleChange(index + 1)}
						sx={{ marginBottom: "8px", borderRadius: "12px" }}
					>
						<AccordionSummary
							expandIcon={<img src={arrowImage} alt="" />}
							aria-controls={`panel${index + 1}bh-content`}
							id={`panel${index + 1}bh-header`}
							sx={{ backgroundColor: "#FBBD05", borderRadius: "12px" }}
						>
							<Typography
								sx={{
									width: "100%",
									flexShrink: 0,
									fontWeight: "700",
									lineHeight: "18px",
									display: "flex",
									alignItems: "center"
								}}
							>
								{item.tag === "loyalty-points" && (
									<CrownIconV2
										width={25}
										height={25}
										style={{ marginRight: "5px" }}
									/>
								)}
								<span>{item.question}</span>
							</Typography>
						</AccordionSummary>
						<CustomAccordionDetails
							$backgroundImage={loyaltyImage}
							className={item.tag}
						>
							{item.answer.type === "text" ? (
								<CustomTypography className={item.tag}>
									{item.answer.content}
								</CustomTypography>
							) : (
								item.answer.type === "steps" &&
								Array.isArray(item.answer.content) && (
									<List disablePadding>
										{item.answer.content.map((step, index) => (
											<ListItem key={index} disablePadding>
												<ListItemIcon
													sx={{ minWidth: "20px", alignSelf: "flex-start" }}
												>
													<DotIcon />
												</ListItemIcon>
												<ListItemText
													primary={step}
													sx={{ marginTop: "2px", marginBottom: "2px" }}
												></ListItemText>
											</ListItem>
										))}
									</List>
								)
							)}
						</CustomAccordionDetails>
					</CustomAccordion>
				))}
			</ItemsContainer>
		</Container>
	);
};
